<template>
  <main class="main" role="main">
    <div class="main__inner"><!-- 배경: bg-->
      <div class="main__con">
        <div class="mypage__page">
          <div class="mypage__page__ttl">고객센터</div>
          <ul class="mypage__page__ul">
            <li class="mypage__page__li" @click="$router.push('/mypage/notice').catch(() => {})">공지사항</li>
            <li class="mypage__page__li" @click="$router.push('/mypage/faq').catch(() => {})">FAQ</li>
<!--            <li class="mypage__page__li" @click="$router.push('/mypage/inquire').catch(() => {})">불편사항 접수</li>-->
          </ul>
          <div class="mypage__page__ttl">계정 관리</div>
          <ul class="mypage__page__ul">
            <li class="mypage__page__li" @click="$router.push('/mypage/modifyCompany').catch(() => {})">기본 정보</li>
            <li class="mypage__page__li" @click="$router.push('/mypage/modifyContact').catch(() => {})">담당자 정보</li>
          </ul>
          <div class="mypage__page__ttl">알림 설정</div>
          <ul class="mypage__page__ul">
            <li class="mypage__page__li">
              <p>운영 알림 설정<br><span class="small">컨설팅 보고서, 공지사항 등 PUSH 알림</span></p>
              <div class="switch_box">
                <label class="switch">
                  <input type="checkbox" class="input" :true-value="1" :false-value="-1" v-model="alrim1" @change="fnChangeAlrim(1)">
                  <span class="slider"></span>
                </label>
              </div>
            </li>
<!--            <li class="mypage__page__li">-->
<!--              <p>이벤트 및 마케팅 알림 설정<br><span class="small">이벤트, 마케팅 등 PUSH 알림</span></p>-->
<!--              <div class="switch_box">-->
<!--                <label class="switch">-->
<!--                  <input type="checkbox" class="input" :true-value="1" :false-value="-1" v-model="alrim2" @change="fnChangeAlrim(2)">-->
<!--                  <span class="slider"></span>-->
<!--                </label>-->
<!--              </div>-->
<!--            </li>-->
            <!--210811 로그아웃 추가-->
            <li class="mypage__page__li" style="justify-content: flex-end;" v-if="userData.userType === 1">
              <div class="header__logout underline" @click="fnLogout()">로그아웃</div>
            </li>
            <li class="mypage__page__li" style="justify-content: space-between;" v-else>
              <div class="header__logout underline" @click="$router.replace('/elect/select')">회원사 선택</div>
              <div class="header__logout underline" @click="fnLogout()" v-show="!isManager">로그아웃</div>
            </li>
            <!--//210811 로그아웃 추가 끝-->
          </ul>
        </div>
      </div>
    </div>
  </main>
</template>
<script>
export default {
  data: function () {
    return {
      isShow: false,
      params: {
        userNo: this.$store.getters['account/getUserData'].userNo,
      },
      alrim1: 1,
      alrim2: -1,
    }
  },
  computed: {
    userData: function () {
      return this.$store.getters['account/getUserData']
    },
    isManager: function () {
      return this.$store.getters['account/getIsManager']
    }
  },
  created: function () {
    this.alrim1 = this.userData.isAlrimOperation
    this.alrim2 = this.userData.isAlrimEvent
  },
  methods: {
    fnChangeAlrim: function(type) {
      const params = { ...this.params }
      params.alrimType = type
        switch (type) {
          case 1 :  params.alrimValue = this.alrim1
              break
          case 2 :  params.alrimValue = this.alrim2
              break
          case 3 :  params.alrimValue = this.alrim3
              break
        }
      this.$AccountSvc.modifyUserAlrim(params)
        .then(res => {
          const code = res.code
          const message = res.message
          const entity = res.entity

          console.log('code: {%d}, message: {%s}, entity: %o', code, message, entity)
          if (code === 1) {
            const _this = this
            setTimeout(function () {
              _this.$Util.refreshUserData()
            }, 200)
          } else {
            switch (type) {
              case 1 :  this.alrim1 = this.alrim1 ? 1 : -1
                  break
              case 2 :  this.alrim2 = this.alrim2 ? 1 : -1
                  break
              case 3 :  this.alrim3 = this.alrim3 ? 1 : -1
                  break
            }
            this.$Util.modalAlert({message: message})
          }
        })
    },
    fnLogout: function () {
      const _this = this
      this.$Util.modalConfirm(this.$ConstCode.CONFIRM_TYPE.LOGOUT, {}, async function () {
        const res = await _this.$AccountSvc.logout()
        const code = res.code
        const message = res.message
        const entity = res.entity

        console.log('code: %d\nmessage: %s\nentity: %o\nstringify: \n%s', code, message, entity, JSON.stringify(entity))
        if (code === 1) {
          setTimeout(function () {
            _this.$router.replace({path: '/account/login'})
          }, 200)
        } else {
          setTimeout(function () {
            _this.$Util.modalAlert({message: message})
          }, 200)
        }
      })
    },
  }
}
</script>
